import React, { Component } from 'react'
import { Link } from "react-router-dom";

class Welcome extends Component {

    render() {
        return (
            <div>
                <div>
                    <div>
                        <div className="mt-10 mx-auto max-w-screen-xl px-4 sm:px-6 md:mt-16 lg:mt-20">
                            <div className="text-center">
                                <h2 className="text-4xl tracking-tight leading-10 font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-6xl">
                                    {process.env.REACT_APP_NAME} <br />
                                    <span className="text-indigo-600">to help in your studio</span>
                                </h2>
                                <p className="mb-4 mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-8 md:mb-8 md:text-xl md:max-w-3xl">
                                    Anim aute id magna aliqua ad ad non deserunt sunt. Qui irure qui lorem cupidatat commodo. Elit sunt amet fugiat veniam occaecat fugiat aliqua.
                                </p>
                            </div>
                        </div>
                    </div >
                    <div className="relative">
                        <div className="absolute inset-0 flex flex-col">
                            <div className="flex-1"></div>
                            <div className="flex-1 w-full bg-gray-800"></div>
                        </div>
                        <div className="max-w-screen-xl mx-auto px-4 sm:px-6">
                            <img className="relative rounded-lg shadow-lg mx-auto" src="images/screenshot.jpg" alt="App screenshot" />
                        </div>

                    </div>
                        <div className="bg-gray-800">
                            <div className="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-between">
                                <h2 className="text-3xl leading-9 font-extrabold tracking-tight text-white sm:text-4xl sm:leading-10">
                                Want to get started?
                                <br />
                                <span className="text-indigo-500">Create an account today.</span>
                                </h2>
                                <div className="mt-8 flex lg:flex-shrink-0 lg:mt-0">
                                    <div className="inline-flex rounded-md shadow">
                                        <Link to="/signup" className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out">
                                        Signup
                                        </Link>
                                    </div>
                                    <div className="ml-3 inline-flex rounded-md shadow">
                                        <Link to="/login" className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-indigo-600 bg-white hover:text-indigo-500 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out">
                                        Login
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div >
                <div className="bg-gray-800">
                    <div className="max-w-screen-xl mx-auto pt-16 pb-20 px-4 sm:px-6 md:pb-24 lg:px-8">
                        <h3 className="text-center text-gray-400 text-sm font-semibold uppercase tracking-wide">Trusted by over 26,000 forward-thinking companies</h3>
                        <div className="mt-8 grid grid-cols-2 gap-8 md:grid-cols-6 lg:grid-cols-5">
                            <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
                                <img className="h-12" src="https://tailwindui.com/img/logos/tuple-logo.svg" alt="Tuple" />
                            </div>
                            <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
                                <img className="h-12" src="https://tailwindui.com/img/logos/mirage-logo.svg" alt="Mirage" />
                            </div>
                            <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
                                <img className="h-12" src="https://tailwindui.com/img/logos/statickit-logo.svg" alt="StaticKit" />
                            </div>
                            <div className="col-span-1 flex justify-center md:col-span-3 lg:col-span-1">
                                <img className="h-12" src="https://tailwindui.com/img/logos/transistor-logo.svg" alt="Transistor" />
                            </div>
                            <div className="col-span-2 flex justify-center md:col-span-3 lg:col-span-1">
                                <img className="h-12" src="https://tailwindui.com/img/logos/workcation-logo.svg" alt="Workcation" />
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default Welcome;